import { Component } from '@angular/core';
import { ErrorPageComponent } from '../error-page/error-page.component';

@Component({
    selector: 'app-error-500',
    standalone: true,
    imports: [ErrorPageComponent],
    templateUrl: './error-500.component.html'
})
export class Error500Component {

}
